<template>
	<v-dialog v-model="dialog" max-width="960px" persistent transition="dialog-bottom-transition" scrollable hide-overlay>
		<v-card>
			<v-toolbar card dark color="info">
				<v-btn icon dark @click.native="closeModal(false)">
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title>{{ template.name }}</v-toolbar-title>
				<v-spacer></v-spacer>

				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-chip color="indigo" dark v-on="on"> V.{{ template.versionNo }} </v-chip>
					</template>
					<span>Document Version: {{ template.versionNo }}</span>
				</v-tooltip>

				<v-btn :loading="isSaving" :disabled="isSaving" dark class="action-btn" @click="onUpdate">
					Update
					<span slot="loader">Updating...</span>
				</v-btn>
			</v-toolbar>
			<v-card-text>
				<v-alert :value="true" class="text-xs-left mb-2" color="warning" outline icon="info">
					By updating this policy, any {{ $term('employee', { plural: true }) }} who have already acknowledged the current version will need to reacknoledge the new version.
				</v-alert>
				<hr-document :hr-document="template" :logged-in-tenant="loggedInTenant" hide-footer is-template :is-admin="isAdmin" />
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'HrDocumentUpdateAvailableModal',
		props: {
			dialog: {
				type: Boolean
			},
			loggedInTenant: {
				type: Object,
				required: true
			},
			isAdmin: {
				type: Boolean,
				required: true
			},
			template: {
				type: Object,
				required: true
			},
			isSaving: {
				type: Boolean,
				required: false
			}
		},
		components: {
			HrDocument: () => import('@/components/hrDocuments/HrDocument')
		},
		methods: {
			closeModal() {
				this.$emit('closeModal');
			},
			onUpdate() {
				if (confirm('Are you sure you want to update this policy?')) this.$emit('onUpdate');
			}
		}
	};
</script>

<style scoped></style>
